// @ts-check

import React from 'react';
import { ErrorValidation, RequiredIcon, Tooltip } from 'core/components';

/**
 * @param {{
 *    campaignName: string
 *    onChange: (e) => void
 *    readonly: boolean
 *    errors?: string []
 * }} props
 */
function CampaignName({ campaignName, onChange, readonly, errors }) {
  return (
    <div className="form-group" id="campaign-name-field">
      <label>
        <RequiredIcon />
        Campaign Name
      </label>
      <Tooltip tooltipId="campaign-name-tooltip">
        The name given to the campaign, potentially public; minimum 5
        characters.
      </Tooltip>
      <input
        data-testid="campaign-name"
        type="text"
        className={`form-control ${errors.length > 0 ? 'is-invalid' : ''}`}
        placeholder="Campaign name or title"
        aria-describedby="error-campaign-name"
        aria-required="true"
        required
        name="campaignName"
        id="campaignName"
        value={campaignName}
        autoComplete="off"
        autoFocus
        readOnly={readonly}
        disabled={readonly}
        onChange={onChange}
      />
      <ErrorValidation errors={errors} />
    </div>
  );
}

export { CampaignName };
